import React from 'react';
import ReactDOM, { createPortal } from 'react-dom';
import { ToastContainer } from 'react-toastify';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { AuthProvider } from './components/providers/AuthProvider';
import 'react-toastify/dist/ReactToastify.css';
import './styles/index.scss';
import './config/i8n';

ReactDOM.render(
  <AuthProvider>
    {createPortal(
      <ToastContainer />,
      document.getElementById('alert-portal')
    )}
    <ToastContainer />
    <App />
  </AuthProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
